<template>
    <div>
        <el-table
                class="mrt10"
                ref="innertable"
                size="mini"
                border
                @selection-change="selectchange"
                max-height="480"
                :data="tableData"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="true"
                style="width: 100%">
            <el-table-column
                    align="center"
                    width="55"
                    type="selection">
            </el-table-column>
            <el-table-column
                    align="center"
                    label="姓名"
                    prop="name" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="部门"
                    prop="dept" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="手机号"
                     show-overflow-tooltip>
                <template slot-scope="scope" >
                    <span>{{scope.row.phone==''?'无':scope.row.phone}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    label="注册时间"
                    prop="registerTime"
            show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block" style="margin: 10px 0px;height: 40px;">
            <div class="pages">
                <div class="choosepage flexother mrt20 fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 50, 100, 400]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            :pager-count="5"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <div style="display:flex;justify-content: center">
            <el-button type="primary" @click="onSubmit" size="mini" :disabled="savebtn">{{$t('button_save')}}</el-button>
            <el-button @click="close" size="mini">取消</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from ".././api.js"
    import {mapActions} from "vuex";

    export default {
        name: "addInnerUser",
        props:{
          deptid:{
              type:Number,
              required:true
          }
        },
        data() {
            return {
                pageSize:10,
                currentPage:1,
                tableData:[],
                total:0,
                selectdata:[],
                savebtn:false
            }
        },
        mounted() {
                this.getInnerUserList()
        },
        methods: {
            close(){
              this.$emit('closedialog')
            },
            onSubmit(){
                this.selectdata=this.selectdata.filter(item=>{
                    return item.list.length>0
                })
                if(this.selectdata.length==0){
                    this.$message.error('请选择人员后保存');
                }else{
                    if(!this.savebtn){
                        this.addWxUser()
                    }
                }
            },
            selectchange(e){
                if(this.selectdata.length==0){
                    this.selectdata.push({
                        page:this.currentPage,
                        list:e
                    })
                }else{
                    if(this.selectdata.findIndex(sitem=>{
                        return sitem.page==this.currentPage
                    })==-1){
                        this.selectdata.push({
                            page:this.currentPage,
                            list:e
                        })
                    }else{
                        this.selectdata.forEach(item=>{
                            if(item.page==this.currentPage){
                                item.list=e
                            }
                        })
                    }
                }
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getInnerUserList()

            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.getInnerUserList()
            },
            ...mapActions(["getCurrentMenuId"]),
            async getInnerUserList(){
                let param = {
                    deptId:this.deptid,
                    pageNum:this.currentPage,
                    pageSize:this.pageSize
                };
                let res = await API.getInnerUserList(param);
                if (res.code == 1) {
                    this.tableData=res.data
                    if(this.selectdata.length!==0){
                        let a=[]
                        this.selectdata.forEach(item=>{
                            item.list.forEach(sitem=>{
                                a.push(sitem.id)
                            })
                        })
                        this.$nextTick(()=>{
                            this.tableData.forEach(item=>{
                                if(a.indexOf(item.id) > -1){
                                    this.$refs.innertable.toggleRowSelection(item,true)
                                }else{
                                    this.$refs.innertable.toggleRowSelection(item,false)
                                }
                            })
                        })

                    }
                    this.total=res.total
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async addWxUser(){
                this.savebtn=true
                // console.log(this.selectdata)
                let a=[]
                this.selectdata.forEach(item=>{
                    a=[...a,...item.list]
                })
                let b=[]
                a.forEach(item=>{
                    b.push({
                        personId:item.id,
                        name:item.name,
                        phone:item.phone,
                        wxContact:item.wxContact,
                        nfc:item.nfc,
                        type:1,
                        isAdmin:item.isAdmin
                    })
                })
                let param = {
                    list:b,
                    lruid:sessionStorage.getItem("userid"),
                    lruName:sessionStorage.getItem("lruname")
                };
                let res = await API.addWxUser(param);
                if (res.code == 1) {
                    this.savebtn=false
                    this.$message.success(res.message)
                    this.$emit('savesuccess')
                } else if (res.code == -2) {
                    this.savebtn=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.savebtn=false

                    this.$message.error(res.message);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
</style>